module.exports = __webpack_public_path__ + "img/cls_ux.50fdaa71.svg";